import { Typography } from '@mui/material';
import React from 'react';

export default function TypographyTitle({ children }) {
  return (
    <Typography fontWeight={800} fontSize={12}>
      {children}
    </Typography>
  );
}
